<template>
  <div class="map-toolbar">
    <div class="toolbar-left">
      <div v-if="$route.meta.fullScreenMap" class="back-btn mb-2" @click="$router.push('/Sarpa/dashboard')">
        <v-icon size="18" color="#000" class="mr-1">mdi-arrow-left</v-icon> Back to Dashboard
      </div>
      <div class="map-title" v-if="title">{{ title }}</div>
      <div class="map-subtitle" v-if="subtitle">{{ subtitle }}</div>
    </div>
    <div class="toolbar-right">
      <MapSearch
        v-if="config.search !== false"
        :search-manager="searchManager"
        class="toolbar-search"
        @result-selected="$emit('search-result', $event)"
      />
    </div>
  </div>
</template>

<script>
import MapSearch from './MapSearch.vue';

export default {
  name: 'MapToolbar',
  components: { MapSearch },
  props: {
    title:         { type: String, default: '' },
    subtitle:      { type: String, default: '' },
    config:        { type: Object, default: () => ({}) },
    searchManager: { type: Object, default: null },
  },
};
</script>

<style scoped>
.map-toolbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 0 16px;
  pointer-events: none;
}

.toolbar-left {
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  background: #ffffff;
  padding: 6px 14px;
  border-radius: 20px;
  font-family: poppinsmedium, 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.back-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.map-title {
  font-family: poppinsmedium, 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  padding: 6px 12px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.map-subtitle {
  font-family: poppinsregular, 'Poppins', sans-serif;
  font-size: 11px;
  color: #6b7280;
  margin-top: 3px;
  padding-left: 4px;
}

.toolbar-right {
  pointer-events: auto;
}

/* The search input sits inside toolbar-right on desktop.
   On mobile we hide it here (MapSearch positions itself absolutely) */
@media (max-width: 600px) {
  .toolbar-right { display: none; }
}
</style>
